import {
  useEffect, useState, useMemo, useCallback,
} from 'react';
// import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import arrayValueType from '@utils/dictionaries/arrayDataValueTypes';

import getColumnsDataInfo from './getColumnsDataInfo';
import getColumnsDetails from './getColumnsDetails';

function useDispositivos_Logs({ bits }) {

  const { t } = useTranslation();
  const [dataSource, setDataSource] = useState(null);
  const columnsDataInfo = useMemo(() => getColumnsDataInfo({ t }), [t]);
  // const clientTarget = useSelector(({ user: u }) => u.clientTarget);
  const categories = [
    'AZURE_ONLINE',
    'AZURE_COM',
    'AZURE_ENABLE',
    'SD_OK',
    'MODBUS_COM',
    'UPDATED_TIME',
    'EXTRTC_OK',
    'UPDATING',
    'UPDATE_OK',
    'HAS_CONN_STR',
    'INTERNET_CONNECTION',
    'RESET_EVENT',
    'RESERVED',
  ];
  const { valueTypeEvents: valueType } = arrayValueType;

  const dataStatus = useCallback(
    () => {

      if (bits !== undefined) {

        const bitsReverse = categories.reverse();
        const data = bitsReverse.map((value, index) => {

          let obj;
          if (index === 0) {

            obj = {
              category: value,
              bit: 2,
            };

          } else if (index === 4 || index === 5) {

            if (bits[index] === 1) {

              obj = {
                category: value,
                bit: 3,
              };

            } else {

              obj = {
                category: value,
                bit: 2,
              };

            }

          } else {

            obj = {
              category: value,
              bit: bits[index],
            };

          }

          return obj;

        });

        setDataSource(data.reverse());

      }

    },
    [bits],
  );

  const columns = useMemo(() => getColumnsDetails({ t }), [t]);

  useEffect(() => {

    dataStatus();

  }, [bits, dataStatus]);

  return {

    columns,
    dataSource,
    columnsDataInfo,
    valueType,

  };

}

export default useDispositivos_Logs;
